document.addEventListener('DOMContentLoaded', () => {


    const slider = document.querySelector('.references-slider');

    // Si le slider n'existe pas → on sort
    if (!slider) return;

    const slidesCount = slider.querySelectorAll('.swiper-slide').length;

    const swiper = new Swiper('.swiper', {
        // Optional parameters
        loop: true,
        slidesPerView: 1,
        spaceBetween: 24, // espace entre les vignettes
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            769: {   // petit mobile / tablette portrait
                slidesPerView: 2,
            },
            1025: {   // desktop
                slidesPerView: 3,
            }
        }
    });



});

